import React from "react";
import HtmlLogo from "./Html.png"
import CssLogo from "./css.png"
import ES5Logo from "./es5.png"
import ES6Logo from "./es6.png"
import BootstrapLogo from "./bootstrap-logo.png"
import JQueryLogo from "./jQuery.png"
import ReactLogo from "./React.png"
import MySqlLogo from "./mySql.png"
import SequelizeLogo from "./Sequelize.png"
import MongoLogo from "./Mongo.png"
import MongooseLogo from "./Mongoose.png"
import "./Skills.css"

const Skills = () => (
  <div className="SkillsMain">

	<h3 className="text-center">Skills</h3>
    <hr/>
    <div>
    <div className="row">
    <div className="col-md-12">
    <div className="LogoRow"/>
    <img src={HtmlLogo} height="60px" alt="Github"/> 
    <img src={CssLogo} height="60px" alt="LinkedIn"/> 
    <img src={ES5Logo} height="60px" alt="es 5"/> 
    <img src={ES6Logo} height="60px" alt="es 6"/> 
    <img src={JQueryLogo} height="60px" alt="jQuery"/> 
    </div>
    </div>
    </div>
    <div>
    <div className="row">
    <div className="col-md-12">
    <div className="LogoRow"/>
    <img src={BootstrapLogo} height="70px" alt="Boostrap"/> 
    <img src={ReactLogo} height="70px" alt="Boostrap"/> 
    </div>
    </div>
    </div>
    <div className="row">
    <div className="col-md-12">
    <div className="LogoRow"/>
    <img src={MySqlLogo} height="70px" alt="My SQL"/> 
    <img src={SequelizeLogo} height="50px" alt="Sequelize"/> 
    </div>
    </div>

    <div className="row">
    <div className="col-md-12">
    <div className="LogoRow"/>
    <img src={MongoLogo} height="70px" alt="Mongo"/> 
    <img src={MongooseLogo} height="70px" alt="Mongoose"/> 
    </div>
    </div>
    </div>

    

    

    

	
);

export default Skills;


// WEBPACK FOOTER //
// ./src/components/Skills/Skills.js